
import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'
import {
  REQUEST_WORKSPACE_NOTIFICATIONS,
  REQUEST_WORKSPACE_NOTIFICATIONS_ERROR,
  RECEIVE_WORKSPACE_NOTIFICATIONS
} from 'actions'

const initialState = {
  isRequesting: false,
  didRequest: false,
  didRequestFail: false,
  data: [],
  error: null
}

const reducer = createApiMiddlewareReducer({
  request: REQUEST_WORKSPACE_NOTIFICATIONS,
  failure: REQUEST_WORKSPACE_NOTIFICATIONS_ERROR,
  receive: RECEIVE_WORKSPACE_NOTIFICATIONS
}, initialState)

export default function (state = initialState, { type, payload = {} }) {
  switch (type) {
    case REQUEST_WORKSPACE_NOTIFICATIONS:
    case REQUEST_WORKSPACE_NOTIFICATIONS_ERROR:
    case RECEIVE_WORKSPACE_NOTIFICATIONS:
      return reducer(state, { type, payload })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/workspace-notifications.js